import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/smile': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM168 240C185.7 240 200 225.7 200 208S185.7 176 168 176 136 190.3 136 208 150.3 240 168 240zM328 240C345.7 240 360 225.7 360 208S345.7 176 328 176 296 190.3 296 208 310.3 240 328 240zM332 312.6C311.2 337.6 280.5 352 248 352S184.8 337.7 164 312.6C155.5 302.4 140.3 301.1 130.2 309.5 120 318 118.7 333.1 127.1 343.3 157.1 379.3 201.2 399.9 248 399.9S338.9 379.3 368.9 343.3C377.4 333.1 376 318 365.8 309.5 355.7 301.1 340.5 302.4 332 312.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/smile.js
// module id = 10vh
// module chunks = 144